// Stable client-side row ids so editable list rows keep their identity (and input
// focus / child state) when rows above them are added, removed or reordered.
let _rowSeq = 0;

export const rowId = () => `r${Date.now().toString(36)}${(_rowSeq++).toString(36)}`;

// Stamps a row id on every object in a list that does not already have one.
export const withRowIds = (items) =>
  Array.isArray(items)
    ? items.map((it) => (it && typeof it === 'object' && !it._rowId ? { ...it, _rowId: rowId() } : it))
    : items;

export const rowKey = (item, index, prefix = 'row') =>
  item && typeof item === 'object' && item._rowId ? item._rowId : `${prefix}-${index}`;

// Deeply removes client-only row ids before sending a payload to the API.
export const stripRowIds = (value) => {
  if (Array.isArray(value)) return value.map(stripRowIds);
  if (value && typeof value === 'object') {
    const out = {};
    Object.entries(value).forEach(([k, v]) => {
      if (k !== '_rowId') out[k] = stripRowIds(v);
    });
    return out;
  }
  return value;
};
